import { Card, CardContent, Grid, Icon, IconButton } from "@mui/material";
import React from "react";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import { theme } from "../../config/theme";
import CoreOutlinedButton from "../../core/inputs/CoreOutlinedButton";

export default function FilterSection({
  filters,
  nativeMuiIconMap = {},
  setFilter,
  iconBgMap = {},
}) {
  const getButton = (filter) => {
    return nativeMuiIconMap[filter?.value?.trim()?.toLowerCase()] ||
      filter?.icon ? (
      <CoreIconButton
        title={filter.label}
        onClick={() => {
          setFilter(filter);
        }}
        iconColor={
          iconBgMap[filter.value]
            ? theme.palette.background
            : theme.palette.secondary.light
        }
        // size="large"
        style={{
          backgroundColor: iconBgMap[filter.value],
          borderRadius: theme.roundness,
          marginLeft: "8px",
        }}
      >
        <Icon>
          {nativeMuiIconMap[filter?.value?.trim()?.toLowerCase()] ||
            filter?.icon}
        </Icon>
      </CoreIconButton>
    ) : (
      <CoreOutlinedButton
        onClick={() => {
          setFilter(filter);
        }}
        style={{
          marginLeft: "8px",
          marginTop: "8px",
        }}
      >
        {filter?.label}
      </CoreOutlinedButton>
    );
  };

  const scrollFilter = (dir) => {
    const scrollOffset = 500;
    if (dir === "left") {
      document.getElementById("scrollable-filter").scrollLeft -= scrollOffset;
    } else if (dir === "right") {
      document.getElementById("scrollable-filter").scrollLeft += scrollOffset;
    }
  };
  return (
    <Card style={{ marginBottom: "0px", marginTop: "8px" }}>
      <CardContent>
        <Grid container>
          <Grid item xs={2}>
            {filters?.slice(0, 3)?.map((filter) => getButton(filter))}
          </Grid>
          <Grid
            item
            xs={10}
            style={{ display: "flex", justifyContent: "space-evenly" }}
          >
            <IconButton
              onClick={() => {
                scrollFilter("left");
              }}
            >
              <Icon>chevron_left</Icon>
            </IconButton>
            <div
              id="scrollable-filter"
              style={{
                minWidth: 200,
                maxWidth: 1000,
                marginLeft: 8,
                marginRight: 8,
                overflowX: "hidden",
                overflowY: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {filters?.slice(3)?.map((filter) => getButton(filter))}
            </div>
            <IconButton
              onClick={() => {
                scrollFilter("right");
              }}
            >
              <Icon>chevron_right</Icon>
            </IconButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
